import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { getMessage, MessageContext } from "react-message-context";
import {
  displayAndFocusAtOpFiTemplateTitle,
  focusToWindow,
  scrollToTop,
} from "../../utils/commonUtils";
import Loading from "../Loading";
import Content from "../form/Content";
import { reaction } from "mobx";
import { ANALYTICS_EVENTS, UNIDENTIFIED } from "../../utils/enums";

const FormPage = observer(
  class FormPage extends React.Component {
    disposer = null;

    componentDidMount() {
      const { RestStore, FeedbackStore, AnalyticsStore, history } = this.props;
      const { apiRoot, restUrl, lang } = window.CFF_PARAMS;

      displayAndFocusAtOpFiTemplateTitle(history.action);

      RestStore.initialiseApi(apiRoot, restUrl);
      AnalyticsStore.setLanguage(lang);
      RestStore.reset();
      FeedbackStore.reset();
      if (!RestStore.customerInfoReceived) {
        RestStore.loadUserInformation(this.callback, this.redirect);
      }

      window.addEventListener("hashchange", this.resetFeedback);

      this.disposer = reaction(
        () => FeedbackStore.isDirty,
        () => {
          window.enableLinkInterruption();
          this.disposer();
          AnalyticsStore.sendPhaseEvent(ANALYTICS_EVENTS.start);
        }
      );

      setTimeout(() => {
        scrollToTop();
        if (history.action !== "PUSH") focusToWindow();
      }, 200);
    }

    componentWillUnmount() {
      this.disposer();
      window.disableLinkInterruption();
      window.removeEventListener("hashchange", this.resetFeedback);
      this.props.SessionStore.clearAll();
    }

    redirect = () => {
	console.log(" FormPage redirect call {} ", this.context);
      this.props.history.push(getMessage(this.context, "url.error")());
    };

    callback = () => {
      const { RestStore, AnalyticsStore } = this.props;

      this.updateUserInformation();
      this.initialiseSessionHandling();

      AnalyticsStore.setCustomerType(RestStore.customerType);
      AnalyticsStore.sendPhaseEvent(ANALYTICS_EVENTS.open);
    };

    updateUserInformation = () => {
      const { RestStore, FeedbackStore } = this.props;
      const { phone, email, address, postalCode } = RestStore;

      FeedbackStore.updateLoggedInUserInfo(phone, email, address, postalCode);
    };

    resetFeedback = () => this.props.FeedbackStore.reset();

    initialiseSessionHandling = () => {
      const { RestStore, SessionStore } = this.props;

      SessionStore.startRefreshSessionInterval(RestStore.keepSessionAlive);
      if (RestStore.customerType === UNIDENTIFIED) {
        SessionStore.startSessionTracking();
      }
    };

    render() {
      const { RestStore } = this.props;
      return <>{RestStore.loading ? <Loading /> : <Content />}</>;
    }
  }
);

FormPage.contextType = MessageContext;

export default withRouter(
  inject(
    "RestStore",
    "FeedbackStore",
    "AnalyticsStore",
    "SessionStore"
  )(FormPage)
);
